import { sbaAxios } from "../utils/sbaAxios";
import { getAssetListDdl } from "../../config/apiConfig";
import {
  FETCH_ASSETLIST_BEGIN_DDL,
  FETCH_ASSETLIST_SUCCESS_DDL,
    FETCH_ASSETLIST_FAILURE_DDL
} from '../constants/assets';


export const getAssestListddlAction=()=> {
  return (dispatch) => {
      dispatch(featchAssetListsBegin());
      sbaAxios({
          url: `${getAssetListDdl}`,
          method: 'get',
      })
      .then((repos) => {
        const AssetList = repos.sort((a, b) =>
        a.AssetName.localeCompare(b.AssetName));
        dispatch(fetchAssetListSuccess(AssetList));
        return AssetList;
      })
      .catch((error) => dispatch(fetchAssetListFailure(error)));
  };
}

export const featchAssetListsBegin = () => ({
  type: FETCH_ASSETLIST_BEGIN_DDL,
});

export const fetchAssetListSuccess = (assetDataItems) => ({
  type: FETCH_ASSETLIST_SUCCESS_DDL,
  payload: {assetDataItems},
});


export const fetchAssetListFailure = (errorMessage) => ({
  type: FETCH_ASSETLIST_FAILURE_DDL,
  payload: {errorMessage}
});

